module.exports = __webpack_public_path__ + "img/phone.977fd6f1.png";